// Bridge: re-export the task detail implementation from `src/projects/pages`
import TaskDetailPage from "../projects/pages/TaskDetailPage";

export default TaskDetailPage;
